<div class="modal-content w-350px overflow-hidden tasks-queue-card__modal">
  <div class="modal-header p-5 border-bottom-0">
    <ng-content select="[title]"></ng-content>
    <div>
      <span
        class="btn btn-icon btn-sm tasks-queue-card__toggle"
        [class.tasks-queue-card__toggle--rotated]="isExpandedBody"
        aria-label="Toggle"
        [inlineSVG]="ICON_CHEVRON_UP"
        (click)="onClickToggle()"
      ></span>
      <span
        class="btn btn-icon btn-sm btn-active-light-primary"
        aria-label="Close"
        [inlineSVG]="ICON_CLOSE"
        (click)="closeCard.emit()"
      ></span>
    </div>
  </div>
  <div
    *ngIf="hasProgressBar"
    class="progress h-5px rounded-0"
    role="progressbar"
    aria-label="Basic example"
    aria-valuenow="0"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div class="progress-bar bg-success" [style.width]="progressBarWidth"></div>
  </div>
  <div
    *ngIf="isExpandedBody"
    @isExpanded
    class="modal-body p-0"
  >
    <ng-content></ng-content>
  </div>
</div>
